import { RecognitionAnchor } from "@common/types/domains/accounting/schedule";

/**
 * The template editor offers one "Source date" option and stores it as
 * `transactionDate`, so both document anchors mean "the date of whatever this
 * schedule is applied to": an invoice's invoice date, a transaction's
 * accounting day, or the entered start for a manual source.
 */
export function isSourceDocumentAnchor(anchor: RecognitionAnchor): boolean {
    return (
        anchor === RecognitionAnchor.invoiceDate ||
        anchor === RecognitionAnchor.transactionDate
    );
}

/** True when any row needs a date the source cannot supply. */
export function hasSpecificDateAnchor(
    components: ReadonlyArray<{ anchor: RecognitionAnchor }>,
): boolean {
    return components.some(
        (component) => component.anchor === RecognitionAnchor.specificDate,
    );
}
